import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getToken } from '@/utils/auth'
import { host } from '@/constant'
import i18n from '@/langs/index'

export const authPrefix = `Bearer `

// 添加防重复提示标志
let isShowingLogoutDialog = false

// 判断是否使用mock数据
const useMock = process.env.NODE_ENV === 'development'

// create an axios instance
const service = axios.create({
  // baseURL: process.env.BASE_API, // api 的 base_url
  baseURL: host, // 恢复原来的baseURL
  timeout: 300000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    // 在开发模式下，如果是mock数据，跳过token验证
    if (store.getters.token && !useMock) {
      // 让每个请求携带token
      config.headers['Authorization'] = getToken()
    }
    return config
  },
  (error) => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  (response) => {
    const res = response.data
    let fileType = ['application/octet-stream', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
    
    if (res.msg !== 'success' && (!fileType.includes(res.type))) {
      // 登录过期拦截 - 只在非mock环境下处理
      if(response.data.code === 403 && !useMock) {
        // 防止重复显示登录过期对话框
        if (!isShowingLogoutDialog && router.history.current.path !== "/" && router.history.current.path !== "/login") {
          isShowingLogoutDialog = true
          MessageBox.confirm(
            i18n.t('request.message'),
            i18n.t('request.title'),
            {
              confirmButtonText: i18n.t('request.confirmButtonText'),
              cancelButtonText: i18n.t('request.cancelButtonText'),
              type: 'warning'
            }
          ).then(() => {
            // 用户选择重新登录
            store.dispatch('FedLogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          }).catch(() => {
            // 用户选择取消，继续留在当前页面
            console.log('用户选择继续留在当前页面')
          }).finally(() => {
            // 重置标志，允许下次显示
            setTimeout(() => {
              isShowingLogoutDialog = false
            }, 1000)
          })
        }
        return Promise.reject(response.data)
      }
      return Promise.reject(response.data)
    } else {
      return response.data
    }
  },
  (error) => {
    console.log(error)
    console.log(error.response)
    // 登录过期拦截 - 只在非mock环境下处理
    if (error.response && error.response.status === 403 && !useMock && !isShowingLogoutDialog) {
      isShowingLogoutDialog = true
      MessageBox.confirm(
        i18n.t('request.message'),
        i18n.t('request.title'),
        {
          confirmButtonText: i18n.t('request.confirmButtonText'),
          cancelButtonText: i18n.t('request.cancelButtonText'),
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('FedLogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      }).catch(() => {
        console.log('用户选择继续留在当前页面')
      }).finally(() => {
        setTimeout(() => {
          isShowingLogoutDialog = false
        }, 1000)
      })
    }
    console.log(error.config.overtimeTips)
    console.log('err' + error) // for debug
    let config = error.config
    if (config.overtimeTips !== 'hide' && error.response.status != 504 && error.response.status != 502) {
      // 超时不提示
      let message =
        error.response && error.response.data && error.response.data.data
          ? error.response.data.data
          :  i18n.t('request.error')
      Message({
        message: message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    // 请求失败后再次请求
    if (config.retry) {
      // Set the variable for keeping track of the retry count
      config.__retryCount = config.__retryCount || 0

      // Check if we've maxed out the total number of retries
      if (config.__retryCount >= config.retry) {
        // Reject with the error
        return Promise.reject(error)
      }

      // Increase the retry count
      config.__retryCount += 1

      // Create new promise to handle exponential backoff
      const backoff = new Promise(function(resolve) {
        setTimeout(function() {
          resolve()
        }, config.retryDelay || 1000)
      })

      // Return the promise in which recalls axios to retry the request
      return backoff.then(function() {
        return axios(config)
      })
    }
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  let config = err.config
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(err)

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err)
  }

  // Increase the retry count
  config.__retryCount += 1

  // Create new promise to handle exponential backoff
  let backoff = new Promise(function(resolve) {
    setTimeout(function() {
      resolve()
    }, config.retryDelay || 1)
  })

  // Return the promise in which recalls axios to retry the request
  return backoff.then(function() {
    return axios(config)
  })
})

export default service
